// client/src/hooks/usePublicSocket.js
// Suscribe una página pública (tienda, citas, noticias) a los cambios en tiempo
// real de su empresa. El cliente no tiene token: se identifica por el slug, que
// el servidor resuelve a la empresa. Cuando llega un evento de la lista, llama a
// onEvent para que la vista vuelva a cargar sus datos sin recargar la página.
import { useEffect, useRef } from 'react';
import { io } from 'socket.io-client';

const SOCKET_BASE = process.env.NODE_ENV === 'production'
  ? window.location.origin
  : 'http://localhost:5000';

export function usePublicSocket(slug, events, onEvent) {
  const onEventRef = useRef(onEvent);
  onEventRef.current = onEvent;
  // Clave estable de los eventos para no reconectar en cada render.
  const evKey = (events || []).join(',');

  useEffect(() => {
    if (!slug) return;
    const socket = io(`${SOCKET_BASE}/public`);
    const join = () => socket.emit('join', { slug });
    socket.on('connect', join); // (re)entrar a la sala al conectar/reconectar
    const list = evKey ? evKey.split(',') : [];
    list.forEach(ev => socket.on(ev, () => onEventRef.current?.(ev)));
    return () => socket.disconnect();
  }, [slug, evKey]);
}
